var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleListings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0703 13C11.0703 11.6739 10.5435 10.4021 9.60585 9.46447C8.66816 8.52678 7.39639 8 6.07031 8C4.74423 8 3.47246 8.52678 2.53478 9.46447C1.5971 10.4021 1.07031 11.6739 1.07031 13",
    stroke: "#43545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.06966 8.00004C7.91061 8.00004 9.40299 6.50766 9.40299 4.66671C9.40299 2.82576 7.91061 1.33337 6.06966 1.33337C4.22871 1.33337 2.73633 2.82576 2.73633 4.66671C2.73633 6.50766 4.22871 8.00004 6.06966 8.00004Z",
    stroke: "#43545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7363 6.33335L14.403 8.00002L17.7363 4.66669",
    stroke: "#43545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleListings);
export default __webpack_public_path__ + "static/media/peopleListings.c0bb3f7b5b2bf7c2b67871c5fcb80191.svg";
export { ForwardRef as ReactComponent };